/// <amd-module name="Wit/Search/SearchWarmer" />
import * as LegacyRestClient from "Wit/Clients/SearchLegacy/RestClient/Search";
import * as SearchSharedLegacy from "Wit/Clients/SearchLegacy/Contracts/Search.SharedLegacy";
import * as WorkItemContracts from "Wit/Clients/SearchLegacy/Contracts/WorkItem";
import { isFeatureFlagEnabled } from "VSS/Platform/Feature";
import { ITfsPageService } from "Tfs/Platform/Page";
import { IVssPageContext } from "VSS/Platform/Context";
import { TimerManagement } from "VSS/Core/TimerManagement";
import { getSetting } from "InstantSearch/Shared/Utils";

export class SearchWarmer {
    private _legacySearchClient: LegacyRestClient.ISearchRestClient;
    private _isSearchWarmerEnabled = false;
    private _warmerRunIntervalInSec = 300; // 5 min
    private _warmerIntervalSettingKey = "Search/Wit/Warmer/Interval"; // set it on TFS as /Configuration/Settings/Host/Search/Wit/Warmer/Interval at collection host level.
    private _projectId: string;
    private _timer = new TimerManagement();
    private _warmerRequest: WorkItemContracts.WorkItemSearchRequest = {
        searchText: "dummy-114B37FF-4996-4976-AE76-4B8DF19BF35D",
        skipResults: 0,
        takeResults: 0,
        summarizedHitCountsNeeded: false,
        includeSuggestions: false,
        searchFilters: {},
        filters: [],
        sortOptions: [],
        isInstantSearch: false
    };

    constructor(private pageContext: IVssPageContext) {
        this._isSearchWarmerEnabled = isFeatureFlagEnabled(this.pageContext, "WebAccess.Search.WorkItem.SearchWarmers", false);
        if (this._isSearchWarmerEnabled) {
            this._legacySearchClient = this.pageContext.getRestClient<LegacyRestClient.ISearchRestClient>("Legacy.ISearchRestClient");
            this._warmerRunIntervalInSec = getSetting<number>(this.pageContext, this._warmerIntervalSettingKey, this._warmerRunIntervalInSec);

            // Determine which projects we should be running warmer on.
            const tfsPageService = this.pageContext.getService<ITfsPageService>("ITfsPageService");
            const tfsPageData = tfsPageService.getData();
            if (tfsPageData && tfsPageData.project) {
                this._projectId = tfsPageData.project.id;
            }
        }
    }

    public initSearchWarmers() {
        if (this._isSearchWarmerEnabled) {
            this.executeSearchWarmer();
        }
    }

    private executeSearchWarmer() {
        try {
            this._legacySearchClient.postWorkItemQuery(this._warmerRequest, this._projectId)
                .then((workItemResponseWithActivityId: SearchSharedLegacy.EntitySearchResponseWithActivityId) => {
                    if (workItemResponseWithActivityId.response.errors.length > 0 &&
                        workItemResponseWithActivityId.response.errors[0].errorCode === "StopWarmerRequests") {
                        this._isSearchWarmerEnabled = false;
                    }
                }, (error: any) => {
                });
        } catch (err) {
            // ignore failures
        } finally {
            // try only for 1 hour.
            if (this._isSearchWarmerEnabled) {
                this._timer.setTimeout(() => this.executeSearchWarmer(), this._warmerRunIntervalInSec * 1000);
            }
        }
    }
}
